import { Component, OnInit } from '@angular/core'
import Swal from 'sweetalert2'
import { AuthenticationService } from '../../../_services/authentication.service'
import { RequestsService } from '../../../_shared/services/requests.service'
import { HelperFunctions } from '../../../_shared/utils/helper-functions'
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms'

declare var jQuery: any

@Component({
  selector: 'app-animal-detail',
  templateUrl: './animal-detail.component.html',
  styleUrls: ['./animal-detail.component.scss'],
})
export class AnimalDetailComponent implements OnInit {
  addAnimalInfoForm: FormGroup
  updateAnimalInfoForm: FormGroup
  addDiagnosisForm: FormGroup
  editDiagnosisForm: FormGroup

  constructor(
    private api: RequestsService,
    private helperFunctions: HelperFunctions,
    private authenticationService: AuthenticationService,
    private requestService: RequestsService,
    private fb: FormBuilder
  ) {}

  animalPage = 1
  count = 10
  animalName: string
  country_id: string
  countryName: string
  inputs: any
  filterInputs: any
  createAnimalInfoisSuccess: boolean
  editAnimalInfoisSuccess: boolean
  loading = false
  animalData: any
  serverError: boolean
  editAnimalError: boolean
  animalInfo: any
  isLoadingAnimalInfo: boolean
  isLoadingAnimalDetails: boolean
  filteranimalInfo: any
  searchItem: string
  deleteAnimalInfoData: any
  createAnimalIsSuccess: boolean
  editAnimalInfoData: any
  selectedInputName: string
  selectedInfo: object[] = []
  animalImage: any
  animalDescription: any
  sub: any
  editError = false
  message: string
  services: any
  diseaseData: any
  isLoadingDiagnosis: boolean
  file: File = null
  category: string
  success = false
  status: string
  singleDiagnosisViewData: any
  deleteDiagnosisSuccess: boolean
  diagnosisId: string
  inputsToSelect: any
  servicesToSelect: any
  selectedItems: any
  selectedServices: any
  savedInputs: Array<any> = []
  savedServices: any
  newInputsArray: any
  newServicesArray: any
  diseaseDataFilter: any
  isEditingDiagnosis: boolean
  isAddingDiagnosis: boolean
  isDeletingDiagnosis: boolean
  isAddingAnimalInfo: boolean
  isEditingAnimalInfo: boolean
  isDeletingAnimalInfo: boolean
  isLoadingInputs: boolean
  requiredField: any = {
    description: false,
    photo: false,
  }
  selectedImage: File = null
  totalFiles: Array<File> = []
  totalFileNames = []
  selectedLanguage: string
  isPublishing: boolean
  publishId: string
  publishStatus: string
  videosToSelect: any
  pestData: any
  pestDataFilter: any

  changeImage(event) {
    this.selectedImage = <File>event.target.files[0]
  }

  appendToFilename(filename, string) {
    let dotIndex = filename.lastIndexOf('.')
    if (dotIndex == -1) return filename + string
    else
      return (
        filename.substring(0, dotIndex) + string + filename.substring(dotIndex)
      )
  }

  changeFiles(event, index) {
    let time_stamp = new Date().getTime()
    if (<File>event.target.files && <File>event.target.files[0]) {
      if (index === 0 && typeof this.totalFiles[index] === 'undefined') {
        this.totalFiles.unshift(<File>event.target.files[0])
        this.totalFileNames.unshift(
          this.appendToFilename(
            <File>event.target.files[0].name,
            '_' + time_stamp
          )
        )
      } else {
        this.totalFiles[index] = <File>event.target.files[0]
        this.totalFileNames[index] = this.appendToFilename(
          <File>event.target.files[0].name,
          '_' + time_stamp
        )
      }
    }
  }

  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ header: 1 }, { header: 2 }],
      ['clean'],
    ],
  }

  editorStyle = {
    height: '100px',
    marginBottom: '10px',
  }

  ngOnInit(): void {
    this.animalName = localStorage.getItem('animal_name')
    this.selectedLanguage = localStorage.getItem('selected_language')
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country } = currentUser
    this.countryName = country

    if (this.countryName === 'Uganda') {
      this.services = [
        'Spraying',
        'Soil testing',
        'Tractor hire',
        'Garden mapping',
      ]
    } else if (this.countryName === 'India') {
      this.services = ['Garden mapping']
    }

    this.addAnimalInfoForm = this.fb.group({
      purpose: ['', Validators.required],
      title: '',
      description: '',
      input: [],
      service: [],
      position: ['', Validators.required],
      media: this.fb.array([]),
    })

    this.updateAnimalInfoForm = this.fb.group({
      purpose: ['', Validators.required],
      title: '',
      description: '',
      input: [],
      service: [],
      position: ['', Validators.required],
      media: this.fb.array([]),
    })

    this.addDiagnosisForm = this.fb.group({
      name: ['', Validators.required],
      cause: '',
      position: ['', Validators.required],
      explanation: '',
      control: '',
      input: [],
      service: [],
      media: this.fb.array([]),
    })

    this.editDiagnosisForm = this.fb.group({
      name: ['', Validators.required],
      cause: '',
      position: ['', Validators.required],
      explanation: '',
      control: '',
      input: [],
      service: [],
      media: this.fb.array([]),
    })

    this.getSingleAnimalsDetails()
    this.getAnimalInfo()
    this.getInputs()
    this.loadDiagnosis(this.category)
    this.getVideos()
  }

  addAnimalMedia(): FormArray {
    return this.addAnimalInfoForm.get('media') as FormArray
  }

  editAnimalMedia(): FormArray {
    return this.updateAnimalInfoForm.get('media') as FormArray
  }

  addAnimalInfoMedia() {
    this.addAnimalMedia().push(this.newMedia())
  }

  editAnimalInfoMedia() {
    this.editAnimalMedia().push(this.newMedia())
  }

  removeAddAnimalMedia(index) {
    this.addAnimalMedia().removeAt(index)
    this.totalFiles.splice(index)
    this.totalFileNames.splice(index)
  }

  removeEditAnimalMedia(index) {
    this.editAnimalMedia().removeAt(index)
    this.totalFiles.splice(index)
    this.totalFileNames.splice(index)
  }

  newMedia(): FormGroup {
    return this.fb.group({
      position: ['', Validators.required],
      photo_url: '',
      video_url: '',
    })
  }

  getSingleAnimalsDetails() {
    this.isLoadingAnimalDetails = true
    this.requestService
      .dash_get(
        `animals/single/update/${this.countryName}/${this.animalName}`,
        null,
        true
      )
      .subscribe((res) => {
        this.isLoadingAnimalDetails = false
        this.animalData = res.data
        this.animalImage = this.animalData.photo_url
        this.animalDescription = this.animalData.description
      })
  }

  getInputs() {
    this.isLoadingInputs = true
    this.requestService
      .dash_get(`mobile/input/${this.countryName}`, null)
      .subscribe((res) => {
        this.isLoadingInputs = false
        let inputs = []
        res.data.map((each) => {
          let input = {
            name: each.name,
            id: each.id,
          }
          inputs.push(input)
        })
        if (this.countryName === 'India') {
          this.inputs = ['AgriGold', 'Allwin', 'Antkiller', 'Bazooka']
        } else if (this.countryName === 'Uganda') {
          this.inputs = inputs
        }
        this.getSelectItems()
      })
  }

  getAnimalInfo() {
    this.isAddingAnimalInfo ||
    this.isEditingAnimalInfo ||
    this.isDeletingAnimalInfo
      ? (this.isLoadingAnimalInfo = false)
      : (this.isLoadingAnimalInfo = true)

    this.requestService
      .dash_get(
        `animals/animal-info/${this.countryName}/${this.animalName}/${this.selectedLanguage}`,
        null,
        true
      )
      .subscribe((res) => {
        this.isLoadingAnimalInfo = false
        let sortedAnimalInfo = []

        res.data
          ? (sortedAnimalInfo = res.data.sort(
              (a: any, b: any) => a.position - b.position
            ))
          : null

        this.animalInfo = sortedAnimalInfo
        this.filteranimalInfo = sortedAnimalInfo
      })
  }

  updateAnimal(createAnimalForm) {
    const form = createAnimalForm
    let formData = new FormData()

    formData.append('animal', form.name)
    formData.append('description', form.description)
    if (this.selectedImage)
      formData.append('photo', this.selectedImage, this.selectedImage.name)
    this.loading = true
    this.requestService
      .dash_putWithImage(
        `animals/single/update/${this.countryName}/${this.animalName}`,
        formData,
        true
      )
      .subscribe(
        (response) => {
          this.loading = false
          if (response.success) {
            this.createAnimalIsSuccess = true
            this.message = response.message
            this.status = 'success'
            this.getSingleAnimalsDetails()
            this.displayAlert(this.message, this.status)
          } else if (!response.success) {
            this.message = response.message
            this.editError = true
          }
        },
        (error) => {
          this.loading = false
          this.message = 'Some error occurred. Please try again'
          this.editError = true
        }
      )
  }

  clearErrorMessage(input) {
    if (input.name === 'description') {
      this.requiredField.explanation = false
    }
  }

  addAnimalInfo() {
    this.loading = true
    let formData = new FormData()
    let animalMedia = []

    if (this.totalFiles && this.totalFiles.length > 0) {
      for (let j = 0; j < this.totalFiles.length; j++) {
        this.totalFiles[j] && this.totalFileNames[j]
          ? formData.append(
              'files[]',
              this.totalFiles[j],
              this.totalFileNames[j]
            )
          : null
      }
    }

    this.addAnimalInfoForm.value.media.forEach((element, index) => {
      let imageUrl = this.totalFileNames[index]
        ? '/images/' + this.totalFileNames[index].replace(/ /g, '')
        : ''

      let mediaObject = {
        position: element.position,
        photo_url: imageUrl,
        video_url: element.video_url,
      }

      animalMedia.push(mediaObject)
    })

    formData.append('title', this.addAnimalInfoForm.value.title)
    formData.append('purpose', this.addAnimalInfoForm.value.purpose)
    formData.append('description', this.addAnimalInfoForm.value.description)
    formData.append('position', this.addAnimalInfoForm.value.position)
    formData.append('input', this.addAnimalInfoForm.value.input)
    formData.append('service', this.addAnimalInfoForm.value.service)
    formData.append('media', JSON.stringify(animalMedia))
    formData.append('language', this.selectedLanguage)

    this.requestService
      .dash_putWithImage(
        `animals/animal-info/${this.countryName}/${this.animalName}`,
        formData,
        true
      )
      .subscribe(
        (response) => {
          this.loading = false
          if (response.success) {
            this.createAnimalInfoisSuccess = true
            this.isAddingAnimalInfo = true
            this.message = 'Animal info added successfully'
            this.status = 'success'
            this.getAnimalInfo()
            this.displayAlert(this.message, this.status)
            this.resetModal()
          } else if (!response.success) {
            this.createAnimalInfoisSuccess = false
            this.message = response.message
            this.serverError = true
            this.status = 'error'
            this.displayAlert(this.message, this.status)
          }
        },
        (errorResponse) => {
          this.loading = false
          this.createAnimalInfoisSuccess = false
          this.message = 'Some error occurred. Please try again'
          this.serverError = true
          this.status = 'error'
          this.displayAlert(this.message, this.status)
        }
      )
  }

  openCity(evt, cityName) {
    // Declare all variables
    var i, tabcontent, tablinks

    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName('tabcontent')
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = 'none'
    }

    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName('tab-link')
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace('active', '')
    }

    // Show the current tab, and add an "active" class to the link that opened the tab
    document.getElementById(cityName).style.display = 'block'
    evt.currentTarget.className += ' active'

    cityName === 'pest' || cityName === 'disease'
      ? this.loadDiagnosis(this.helperFunctions.capitalize(cityName))
      : ''
  }

  editAnimalInfoDetails(data: object) {
    this.editAnimalInfoisSuccess = false
    this.isEditingAnimalInfo = true
    this.editAnimalInfoData = data
    this.publishId = this.editAnimalInfoData.id
    this.publishStatus =
      this.editAnimalInfoData.status === 'inactive' ? 'inactive' : 'active'
    this.selectedLanguage = this.editAnimalInfoData.language

    this.editAnimalInfoData.input
      ? this.editAnimalInfoData.input.map((element) => {
          this.retrieveInputName(element)
        })
      : null

    this.savedServices = this.editAnimalInfoData.service

    this.updateAnimalInfoForm.patchValue({
      purpose: this.editAnimalInfoData.purpose,
      title: this.editAnimalInfoData.title,
      description: this.editAnimalInfoData.description,
      position: this.editAnimalInfoData.position,
    })
    let sortedMedia = []

    this.editAnimalInfoData.media
      ? (sortedMedia = this.editAnimalInfoData.media.sort(
          (a: any, b: any) => a.position - b.position
        ))
      : null
    this.updateAnimalInfoForm.setControl(
      'media',
      this.setExistingMedia(sortedMedia)
    )
  }

  setExistingMedia(existingMedia): FormArray {
    const formArray = new FormArray([])
    existingMedia
      ? existingMedia.forEach((element) => {
          formArray.push(
            this.fb.group({
              photo_url: element.photo_url,
              position: element.position,
              video_url: element.video_url,
            })
          )
        })
      : null
    return formArray
  }

  retrieveInputName(inputId: string) {
    this.isLoadingInputs = true
    this.requestService
      .dash_get(`mobile/input/name/${inputId}`, null)
      .subscribe((res) => {
        this.isLoadingInputs = false
        this.selectedInputName = res.data
        let input = {
          id: inputId,
          name: this.selectedInputName,
        }
        this.savedInputs.push(input)
      })
  }

  onAnimalVideoChange(event, index) {
    let videoTag

    jQuery(document).ready(() => {
      if (this.isEditingAnimalInfo) {
        videoTag = jQuery('#edit-animalvid-tag' + index)[0]
      } else {
        videoTag = jQuery('#add-animalvid-tag' + index)[0]
      }
      videoTag.load()
    })
  }

  updateAnimalInfo(id) {
    this.loading = true
    const URL = `animals/animal-info/update/${this.countryName}/${this.animalName}/${id}`
    let formData = new FormData()
    let animalMedia = []

    if (this.totalFiles && this.totalFiles.length > 0) {
      for (let j = 0; j < this.totalFiles.length; j++) {
        this.totalFiles[j] && this.totalFileNames[j]
          ? formData.append(
              'files[]',
              this.totalFiles[j],
              this.totalFileNames[j]
            )
          : null
      }
    }

    this.updateAnimalInfoForm.value.media.forEach((element, index) => {
      let imageUrl = this.totalFileNames[index]
        ? '/images/' + this.totalFileNames[index].replace(/ /g, '')
        : element.photo_url

      let mediaObject = {
        position: element.position,
        photo_url: imageUrl,
        video_url: element.video_url,
      }

      animalMedia.push(mediaObject)
    })

    let newInputsArray = []
    let newServicesArray = []
    let savedInputsIds = []

    this.savedInputs
      ? this.savedInputs.map((each) => {
          savedInputsIds.push(each.id)
        })
      : null

    newInputsArray = [
      ...(this.updateAnimalInfoForm.value.input || []),
      ...(savedInputsIds || []),
    ]
    this.newInputsArray = Array.from(new Set(newInputsArray))

    newServicesArray = [
      ...(this.updateAnimalInfoForm.value.service || []),
      ...(this.savedServices || []),
    ]
    this.newServicesArray = Array.from(new Set(newServicesArray))

    formData.append('animal', this.animalName)
    formData.append('purpose', this.updateAnimalInfoForm.value.purpose)
    formData.append('title', this.updateAnimalInfoForm.value.title)
    formData.append('description', this.updateAnimalInfoForm.value.description)
    formData.append('position', this.updateAnimalInfoForm.value.position)
    formData.append('input', this.newInputsArray)
    formData.append('service', this.newServicesArray)
    formData.append('media', JSON.stringify(animalMedia))
    formData.append('language', this.selectedLanguage)

    this.requestService.dash_putWithImage(URL, formData, true).subscribe(
      (response) => {
        this.loading = false
        if (response.success) {
          this.editAnimalInfoisSuccess = true
          this.message = 'Animal info edited successfully'
          this.status = 'success'
          this.getAnimalInfo()
          this.displayAlert(this.message, this.status)
          this.resetEditModal()
        } else if (!response.success) {
          this.message = response.message
          this.editAnimalError = true
          this.status = 'error'
          this.displayAlert(this.message, this.status)
        }
      },
      (error) => {
        this.loading = false
        this.message = 'Some error occurred. Please try again'
        this.editError = true
        this.status = 'error'
        this.displayAlert(this.message, this.status)
      }
    )
  }

  deleteAnimalInfoDetails(data: object): void {
    this.deleteAnimalInfoData = data
  }

  resetModal() {
    jQuery('#animalModal').modal('hide')
    this.createAnimalInfoisSuccess = false
    this.serverError = false
    this.isAddingAnimalInfo = false
    this.addAnimalInfoForm.reset()
    this.addAnimalMedia().controls = []
    this.resetFiles()
  }

  resetEditModal() {
    jQuery('#editAnimalInfoModal').modal('hide')
    this.editAnimalInfoisSuccess = false
    this.editAnimalError = false
    this.isEditingAnimalInfo = false
    this.updateAnimalInfoForm.reset()
    this.resetFiles()
    this.savedInputs = []
    this.savedServices = []
  }

  loadDiagnosis(category: any): void {
    this.category = category
    this.isAddingDiagnosis ||
    this.isEditingDiagnosis ||
    this.isDeletingDiagnosis
      ? (this.isLoadingDiagnosis = false)
      : (this.isLoadingDiagnosis = true)
    this.requestService
      .dash_get(
        `animals/diagnosis/${this.countryName}/${category}/${this.animalName}/${this.selectedLanguage}`,
        null,
        true
      )
      .subscribe(
        (res) => {
          this.isLoadingDiagnosis = false
          let sortedDiagnosisdata = []

          res.data
            ? (sortedDiagnosisdata = res.data.sort(
                (a: any, b: any) => a.position - b.position
              ))
            : null
          if (category === 'Disease') {
            this.diseaseData = sortedDiagnosisdata
            this.diseaseDataFilter = sortedDiagnosisdata
          } else if (category === 'Pest') {
            this.pestData = sortedDiagnosisdata
            this.pestDataFilter = sortedDiagnosisdata
          }
        },
        (err) => {
          this.isLoadingDiagnosis = false
          this.message = err.error
        }
      )
  }

  addDiagnosisMedia(): FormArray {
    return this.addDiagnosisForm.get('media') as FormArray
  }

  editDiagnosisMedia(): FormArray {
    return this.editDiagnosisForm.get('media') as FormArray
  }

  addDiagMedia() {
    this.addDiagnosisMedia().push(this.newMedia())
  }

  editDiagMedia() {
    this.editDiagnosisMedia().push(this.newMedia())
  }

  removeAddDiagMedia(index) {
    this.addDiagnosisMedia().removeAt(index)
    this.totalFiles.splice(index)
    this.totalFileNames.splice(index)
  }

  removeEditDiagMedia(index) {
    this.editDiagnosisMedia().removeAt(index)
    this.totalFiles.splice(index)
    this.totalFileNames.splice(index)
  }

  closeAddDiagModal() {
    jQuery(document).ready(() => {
      this.isAddingDiagnosis = false
      jQuery('#addDiagnosisModal').modal('hide')
      this.addDiagnosisMedia().controls = []
      this.addDiagnosisForm.reset()
      this.resetFiles()
    })
  }

  addDiagnosis() {
    this.loading = true
    const formData = new FormData()
    let diagnosisMedia = []

    if (this.totalFiles && this.totalFiles.length > 0) {
      for (let j = 0; j < this.totalFiles.length; j++) {
        this.totalFiles[j] && this.totalFileNames[j]
          ? formData.append(
              'files[]',
              this.totalFiles[j],
              this.totalFileNames[j]
            )
          : null
      }
    }

    this.addDiagnosisForm.value.media.forEach((element, index) => {
      let imageUrl = this.totalFileNames[index]
        ? '/images/' + this.totalFileNames[index].replace(/ /g, '')
        : ''

      let mediaObject = {
        position: element.position,
        photo_url: imageUrl,
        video_url: element.video_url,
      }

      diagnosisMedia.push(mediaObject)
    })

    formData.append('animal', this.animalName)
    formData.append('name', this.addDiagnosisForm.value.name)
    formData.append('cause', this.addDiagnosisForm.value.cause)
    formData.append('position', this.addDiagnosisForm.value.position)
    formData.append('control', this.addDiagnosisForm.value.control)
    formData.append('explanation', this.addDiagnosisForm.value.explanation)
    formData.append('input', this.addDiagnosisForm.value.input)
    formData.append('service', this.addDiagnosisForm.value.service)
    formData.append('media', JSON.stringify(diagnosisMedia))
    formData.append('language', this.selectedLanguage)

    this.requestService
      .dash_putWithImage(
        `animals/diagnosis/${this.countryName}/${this.category}`,
        formData,
        true
      )
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = `${this.category} added successfully`
            this.success = true
            this.status = 'success'
            this.isAddingDiagnosis = true
            this.loadDiagnosis(this.category)
            this.displayAlert(this.message, this.status)
            this.closeAddDiagModal()
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.displayAlert(this.message, this.status)
        }
      )
  }

  deleteAnimalInfo(id) {
    this.loading = true
    this.requestService
      .dash_delete(
        id,
        `animals/animal-info/delete/${this.countryName}/${this.animalName}`,
        true
      )
      .subscribe(
        (res) => {
          this.loading = false
          this.isDeletingAnimalInfo = true
          if (res.success) {
            this.message = res.message
            this.status = 'success'
            this.getAnimalInfo()
            this.displayAlert(this.message, this.status)
            this.resetDeleteAnimalInfoModal()
          }
        },
        (err) => {
          this.loading = false
          if (err.status === 404) {
            this.message = 'Animal information not found!'
          } else {
            this.message = 'Some error occurred. Please try again'
            this.status = 'error'
            this.displayAlert(this.message, this.status)
            this.resetDeleteAnimalInfoModal()
          }
        }
      )
  }

  closeEditDiagModal() {
    jQuery(document).ready(() => {
      this.isEditingDiagnosis = false
      jQuery('#editDiagnosisModal').modal('hide')
      this.editDiagnosisForm.reset()
      this.resetFiles()
      this.savedInputs = []
      this.savedServices = []
    })
  }

  getSingleDiagnosisViewData(data: object) {
    this.isEditingDiagnosis = true
    this.singleDiagnosisViewData = data
    this.diagnosisId = this.singleDiagnosisViewData.id
    this.publishId = this.singleDiagnosisViewData.id
    this.publishStatus =
      this.singleDiagnosisViewData.status === 'inactive' ? 'inactive' : 'active'
    this.selectedLanguage = this.singleDiagnosisViewData.language

    this.singleDiagnosisViewData.input
      ? this.singleDiagnosisViewData.input.map((element) => {
          this.retrieveInputName(element)
        })
      : null

    this.savedServices = this.singleDiagnosisViewData.service

    this.editDiagnosisForm.patchValue({
      name: this.singleDiagnosisViewData.name,
      cause: this.singleDiagnosisViewData.cause,
      position: this.singleDiagnosisViewData.position,
      explanation: this.singleDiagnosisViewData.explanation,
      control: this.singleDiagnosisViewData.control,
    })
    let sortedMedia = []

    this.singleDiagnosisViewData.media
      ? (sortedMedia = this.singleDiagnosisViewData.media.sort(
          (a: any, b: any) => a.position - b.position
        ))
      : null
    this.editDiagnosisForm.setControl(
      'media',
      this.setExistingMedia(sortedMedia)
    )
  }

  getEditingStatus(isEditing: boolean) {
    this.isEditingDiagnosis = isEditing
  }

  onDiagVideoChange(event, index) {
    let videoTag

    jQuery(document).ready(() => {
      if (this.isEditingDiagnosis) {
        videoTag = jQuery('#edit-diagvid-tag' + index)[0]
      } else {
        videoTag = jQuery('#add-diagvid-tag' + index)[0]
      }
      videoTag.load()
    })
  }

  editDiagnosis() {
    this.loading = true
    let formData = new FormData()
    let diagnosisMedia = []

    if (this.totalFiles && this.totalFiles.length > 0) {
      for (let j = 0; j < this.totalFiles.length; j++) {
        this.totalFiles[j] && this.totalFileNames[j]
          ? formData.append(
              'files[]',
              this.totalFiles[j],
              this.totalFileNames[j]
            )
          : null
      }
    }

    this.editDiagnosisForm.value.media.forEach((element, index) => {
      let imageUrl = this.totalFileNames[index]
        ? '/images/' + this.totalFileNames[index].replace(/ /g, '')
        : element.photo_url

      let mediaObject = {
        position: element.position,
        photo_url: imageUrl,
        video_url: element.video_url,
      }
      diagnosisMedia.push(mediaObject)
    })

    let newInputsArray = []
    let newServicesArray = []
    let savedInputsIds = []

    this.savedInputs
      ? this.savedInputs.map((each) => {
          savedInputsIds.push(each.id)
        })
      : null

    newInputsArray = [
      ...(this.editDiagnosisForm.value.input || []),
      ...(savedInputsIds || []),
    ]
    this.newInputsArray = Array.from(new Set(newInputsArray))

    newServicesArray = [
      ...(this.editDiagnosisForm.value.service || []),
      ...(this.savedServices || []),
    ]
    this.newServicesArray = Array.from(new Set(newServicesArray))

    formData.append('name', this.editDiagnosisForm.value.name)
    formData.append('control', this.editDiagnosisForm.value.control)
    formData.append('explanation', this.editDiagnosisForm.value.explanation)
    formData.append('position', this.editDiagnosisForm.value.position)
    formData.append('animal', this.animalName)
    formData.append('input', this.newInputsArray)
    formData.append('cause', this.editDiagnosisForm.value.cause)
    formData.append('service', this.newServicesArray)
    formData.append('media', JSON.stringify(diagnosisMedia))
    formData.append('language', this.selectedLanguage)

    this.api
      .dash_putWithImage(
        `animals/diagnosis/update/${this.countryName}/${this.category}/${this.diagnosisId}`,
        formData,
        true
      )
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success) {
            this.message = `${this.category} has been edited successfully`
            this.status = 'success'
            this.loadDiagnosis(this.category)
            this.displayAlert(this.message, this.status)
            this.closeEditDiagModal()
          } else if (!res.success) {
            this.message = res.message
            this.status = 'error'
            this.displayAlert(this.message, this.status)
          }
        },
        (error) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.displayAlert(this.message, this.status)
        }
      )
  }

  resetDeleteAnimalInfoModal() {
    jQuery('#deleteModal').modal('hide')
    this.isDeletingAnimalInfo = false
  }

  filterAnimalInfoFunction(event) {
    this.searchItem = event.target.value
    this.filteranimalInfo = this.animalInfo.filter(
      (input) =>
        input.title.toLowerCase().indexOf(this.searchItem.toLowerCase()) !==
          -1 ||
        input.purpose.toLowerCase().indexOf(this.searchItem.toLowerCase()) !==
          -1
    )
  }

  deleteDiagnosis(id: string): void {
    this.loading = true
    this.requestService
      .dash_delete(
        id,
        `animals/diagnosis/delete/${this.countryName}/${this.category}/${this.animalName}`,
        true
      )
      .subscribe(
        (res) => {
          this.loading = false
          this.deleteDiagnosisSuccess = true
          this.status = 'success'
          this.isDeletingDiagnosis = true
          this.loadDiagnosis(this.category)
          this.message = `${this.category} deleted successfully`
          this.displayAlert(this.message, this.status)
          jQuery(document).ready(() => {
            this.isDeletingDiagnosis = false
            jQuery('#deleteDiagModal').modal('hide')
          })
        },
        (err) => {
          this.loading = false
          this.deleteDiagnosisSuccess = false
          if (err.status === 404) {
            this.message = 'Diagnosis information not found!'
          } else {
            this.message = 'Some error occurred. Please try again'
            this.status = 'error'
            this.displayAlert(this.message, this.status)
            jQuery(document).ready(() => {
              this.isDeletingDiagnosis = false
              jQuery('#deleteDiagModal').modal('hide')
            })
          }
        }
      )
  }

  displayAlert(message, status) {
    const title = status.charAt(0).toUpperCase() + status.slice(1)
    Swal.fire(title, message, status)
  }

  getSelectItems() {
    let services = []
    let inputItems = []

    this.services
      ? this.services.map((each) => {
          services.push({ label: each, value: each })
          this.servicesToSelect = services
        })
      : null

    this.inputs
      ? this.inputs.map((each) => {
          inputItems.push({ label: each.name, value: each.id })
          this.inputsToSelect = inputItems
        })
      : null
  }

  removeInput(index: number) {
    let newArr = []

    if (this.savedInputs) {
      newArr = this.savedInputs
      newArr.splice(index, 1)
      this.savedInputs = newArr
    }
  }

  removeService(index: number) {
    let newArr = []

    if (this.savedServices) {
      newArr = this.savedServices
      newArr.splice(index, 1)
      this.savedServices = newArr
    }
  }

  onClickOutside() {
    jQuery(document).ready(() => {
      jQuery('#addDiagnosisModal').on('hidden.bs.modal', () => {
        this.closeAddDiagModal()
      })
      jQuery('#editDiagnosisModal').on('hidden.bs.modal', () => {
        this.closeEditDiagModal()
      })
      jQuery('#animalModal').on('hidden.bs.modal', () => {
        this.resetModal()
      })
      jQuery('#editAnimalInfoModal').on('hidden.bs.modal', () => {
        this.resetEditModal()
      })
      jQuery('#deleteModal').on('hidden.bs.modal', () => {
        this.resetDeleteAnimalInfoModal()
      })
    })
  }

  resetFiles() {
    this.totalFiles = []
    this.totalFileNames = []
  }

  publishContent(id: string) {
    this.loading = true

    this.requestService.dash_put(`publish_or_unpublish/${id}`, null).subscribe(
      (res) => {
        this.loading = false
        if (res.success === true) {
          this.status = 'success'
          this.isPublishing = true
          this.getAnimalInfo()
          this.loadDiagnosis(this.category)
          this.message = res.message
          this.displayAlert(this.message, this.status)
          jQuery(document).ready(() => {
            this.isPublishing = false
            jQuery('#publishModal').modal('hide')
          })
        } else if ((res.success = false)) {
          this.status = 'error'
          this.message = res.message
          this.displayAlert(this.message, this.status)
        }
      },
      (err) => {
        this.loading = false
        if (err.status === 404) {
          this.message = 'Content not found!'
        } else {
          this.message = 'Some error occurred. Please try again'
          this.status = 'error'
          this.displayAlert(this.message, this.status)
          jQuery(document).ready(() => {
            this.isPublishing = false
            jQuery('#publishModal').modal('hide')
          })
        }
      }
    )
  }

  checkPublishStatus(status: string, content) {
    return status === content.status
  }

  getNutritionPublishId(id: string) {
    this.publishId = id
  }

  getNutritionPublishStatus(status: string) {
    this.publishStatus = status
  }

  getVideos() {
    this.isLoadingInputs = true
    this.requestService
      .dash_get(`videos/upload/${this.countryName}`, null)
      .subscribe((res) => {
        let videos = []
        res.data
          ? res.data.map((each) => {
              videos.push({ label: each.title, value: each.video_url })
              this.videosToSelect = videos
            })
          : null
      })
  }
}
